
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockBacProcessingGrid extends Serenity.EntityGrid<IcStockBacProcessingRow, any> {
        protected getColumnsKey() { return IcStockBacProcessingColumns.columnsKey; }
        protected getDialogType() { return IcStockBacProcessingDialog; }
        protected getIdProperty() { return IcStockBacProcessingRow.idProperty; }
        protected getInsertPermission() { return IcStockBacProcessingRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockBacProcessingRow.localTextPrefix; }
        protected getService() { return IcStockBacProcessingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}